export const WA = {
  info: "https://wa.me/573104329342?text=Hola%2C%20quiero%20informaci%C3%B3n%20del%20analizador%20EH8300%20VET",
  quote: "https://wa.me/573104329342?text=Hola%2C%20quiero%20cotizar%20el%20analizador%20EH8300%20VET",
  offer: "https://wa.me/573104329342?text=Hola%2C%20quiero%20aprovechar%20el%20precio%20de%20lanzamiento%20del%20EH8300%20VET",
};

export const PHONE = {
  tel: "tel:+573104329342",
  display: "310 432 9342",
  intl: "+57 310 432 9342",
};

export const DATASHEET = {
  url: "/ficha-tecnica-eh8300-vet.pdf",
  filename: "Ficha-tecnica-Excbio-EH8300-VET-Hamburger-Invitro.pdf",
  label: "Descargar ficha técnica (PDF)",
};

export const SOCIALS = {
  instagram: { handle: "@hamburgerinvitro", url: "https://instagram.com/hamburgerinvitro" },
  youtube: { handle: "@hamburgerinvitro", url: "https://youtube.com/@hamburgerinvitro" },
  tiktok: { handle: "@hamburger.invitro", url: "https://tiktok.com/@hamburger.invitro" },
};

export const IMAGES = {
  hero: "https://static.prod-images.emergentagent.com/jobs/75dd5e72-6438-4912-9c7d-3246595a3919/images/1f0c9c793f11c643990c3fba3969fa4f62ac91044bfe37ee712506af52699b55.jpeg",
  scene: "https://static.prod-images.emergentagent.com/jobs/75dd5e72-6438-4912-9c7d-3246595a3919/images/6ffbd27faa355b058306803d85f0130a67c884d87639abe961fa518d2c3b80dd.jpeg",
  cells: "https://static.prod-images.emergentagent.com/jobs/75dd5e72-6438-4912-9c7d-3246595a3919/images/a519cba348f53a529b743f24a572bf6cdb059577ce089b53c21b6a42cf761b22.jpeg",
  real: "https://customer-assets-jai6qajn.emergentagent.net/job_75dd5e72-6438-4912-9c7d-3246595a3919/artifacts/525674c571d721db_eh%208300%20vet%20foto%20real.webp",
  render: "https://customer-assets-jai6qajn.emergentagent.net/job_75dd5e72-6438-4912-9c7d-3246595a3919/artifacts/adc9afbd1ca62a39_eh%208300%20vet.webp",
  vetSample: "https://images.unsplash.com/photo-1770836037275-38b44e4b101f?auto=format&fit=crop&w=900&q=80",
  vetExam: "https://images.unsplash.com/photo-1770836037793-95bdbf190f71?auto=format&fit=crop&w=900&q=80",
  lab: "https://images.unsplash.com/photo-1614308460927-5024ba2e1dcb?auto=format&fit=crop&w=900&q=80",
};

export const PRICES = {
  before: "$18.000.000",
  now: "$15.900.000",
  iva: "+ IVA",
  savings: "$2.100.000",
};

export const MARQUEE_ITEMS = [
  "24 parámetros + 3 histogramas",
  "60 muestras / hora",
  "Micromuestra 9,6 µl",
  "Sistema abierto sin código de barras",
  "+200.000 resultados almacenados",
  "11 especies + 14 personalizables",
  "Pantalla táctil LED de 10″",
  "Garantía de 1 año",
];

export const SPECIES = [
  { name: "Perro" },
  { name: "Gato" },
  { name: "Caballo" },
  { name: "Vaca" },
  { name: "Cerdo" },
  { name: "Oveja" },
  { name: "Cabra" },
  { name: "Conejo" },
  { name: "Ratón" },
  { name: "Mono" },
  { name: "Cerdo vietnamita" },
];

export const PARAMETERS = [
  "WBC", "HGB", "LYM#", "LYM%", "MID#", "MID%", "GRA#", "GRA%",
  "RBC", "HCT", "MCV", "MCH", "MCHC", "RDW-CV", "RDW-SD",
  "PLT", "MPV", "PCT", "PDW", "P-LCR", "P-LCC",
];

export const SPECS = [
  { k: "Principio de medición", v: "Impedancia eléctrica para conteo celular; método SFT para hemoglobina" },
  { k: "Diferencial leucocitario", v: "3 partes: LYM · MID · GRA" },
  { k: "Rendimiento", v: "60 muestras por hora" },
  { k: "Volumen de muestra", v: "9,6 µl de sangre total · 20 µl en prediluida" },
  { k: "Modos de muestra", v: "Sangre total venosa, sangre total capilar y sangre prediluida" },
  { k: "Reactivos", v: "Solo 2: diluyente y lisante. Sistema abierto sin código de barras" },
  { k: "Especies", v: "11 preconfiguradas + 14 personalizables" },
  { k: "Calibración y QC", v: "Calibración manual y automática · Gráficas L-J y X-B" },
  { k: "Almacenamiento", v: "Más de 200.000 resultados con histogramas y datos del paciente" },
  { k: "Pantalla", v: "Táctil LED a color de 10 pulgadas · mouse y teclado externos" },
  { k: "Impresión", v: "Conexión opcional a impresora externa · reportes personalizables" },
  { k: "Idiomas", v: "Español, inglés, francés, ruso, ucraniano y chino" },
];

export const DAY_ITEMS = [
  {
    title: "Resultados precisos",
    body: "Microporo de rubí y flujo laminar por presión negativa de doble canal para un conteo celular estable.",
  },
  {
    title: "Control de calidad integrado",
    body: "Gráficas L-J y X-B automáticas, calibración manual y automática para cada modo de muestra.",
  },
  {
    title: "Micromuestra",
    body: "9,6 µl en sangre venosa o capilar y 20 µl en prediluida. Ideal para pacientes pequeños y nerviosos.",
  },
  {
    title: "Mantenimiento sencillo",
    body: "Diseño de 3 puertas, autodiagnóstico completo y lavado automático al encender y apagar.",
  },
  {
    title: "Más de 200.000 resultados",
    body: "Almacena resultados con histogramas y datos del paciente, con búsqueda combinada por varios criterios.",
  },
];

export const INCLUDED = [
  { title: "Instalación y puesta en marcha", body: "En tu clínica, listo para operar." },
  { title: "Capacitación para tu personal", body: "Para que el equipo trabaje desde el día uno." },
  { title: "Kit inicial de reactivos", body: "Diluyente y lisante para empezar de inmediato." },
  { title: "Garantía de 1 año", body: "Respaldo directo de fábrica y de Hamburger Invitro." },
];

export const FAQS = [
  {
    q: "¿Qué incluye la oferta de lanzamiento?",
    a: "El Excbio EH8300 VET con instalación y puesta en marcha en tu clínica, capacitación para tu personal, kit inicial de reactivos y garantía de 1 año.",
  },
  {
    q: "¿Estoy obligado a comprar reactivos con código o tarjeta?",
    a: "No. El EH8300 VET es un sistema abierto sin código de barras: funciona solo con dos reactivos (diluyente y lisante) y tú decides a quién le compras tus reactivos.",
  },
  {
    q: "¿Qué garantía y soporte tiene el equipo?",
    a: "Garantía de 1 año y soporte técnico especializado de Hamburger Invitro: mantenimiento preventivo y correctivo a cargo de un ingeniero biomédico con más de 12 años de experiencia en hematología, química, electrolitos y coagulación.",
  },
  {
    q: "¿Cuántos resultados puede almacenar el equipo?",
    a: "Más de 200.000 resultados con histogramas y datos del paciente, con búsqueda combinada por varios criterios.",
  },
  {
    q: "¿En qué idiomas está disponible el software?",
    a: "Español, inglés, francés, ruso, ucraniano y chino. La pantalla táctil de 10 pulgadas también admite mouse y teclado externos.",
  },
];

export const fmtCOP = (n) =>
  new Intl.NumberFormat("es-CO", {
    style: "currency",
    currency: "COP",
    maximumFractionDigits: 0,
  }).format(n);
